import React from 'react';
import PropTypes from 'prop-types';

import List from './List';
import Scale from '../elements/Scale';
import MenuHeader from './MenuHeader';

import {ReactComponent as BackIcon} from '../icons/back-icon.svg';

const icons = {
  back: <BackIcon className="Icon-topbar" />,
}

const ListMenu = ({ name, parentName, settings, title, index, indexChild, showSubList, menuLevel }) => {
    let listItemIndex = index;
    let listItemIndexForS;
    
    const buttonClass = index === -1 
    ? 'Back-button  Back-button-active' 
    : showSubList === true ? 'Back-button hidden' : 'Back-button';

    let list = [];
    for (const el in settings) {
      list.push(settings[el]);
    }

    const rowAmount = menuLevel === 5 || title ? 7 : 8; 

    let itemLineNumber = 0;
    let itemsToRender = [];

    list.forEach((listItem, index, array) => {
        let itemClassName = 'List-item ';
        listItem.disabled ? (itemClassName += ' disabled') : (itemClassName += '');
        
        if (showSubList === true) {
            index === listItemIndex ? (itemClassName += ' List-item-with-sublist') : (itemClassName += ' hidden');
        } else {
            index === listItemIndex ? (itemClassName += ' List-item-active') : (itemClassName += '');
        }

        if(index === listItemIndex) { listItemIndexForS = itemLineNumber };

        if (array.length <= rowAmount) {
            listItem.className = itemClassName;
            itemsToRender.push(listItem);
            itemLineNumber += 1;
        } else if (listItemIndex < rowAmount - 1) {
            if (index <= rowAmount - 1) {
                listItem.className = itemClassName;
                itemsToRender.push(listItem);
                itemLineNumber += 1;
            }
        } else {
            if (listItemIndex === array.length - 1) {
              if (index > listItemIndex - rowAmount && index <= listItemIndex + 1) {
                listItem.className = itemClassName;
                itemsToRender.push(listItem);
                itemLineNumber += 1;
              } 
            } else {
              if (index > listItemIndex - rowAmount + 1 && index <= listItemIndex + 1) {
                listItem.className = itemClassName;
                itemsToRender.push(listItem);
                itemLineNumber += 1;
              } 
            }
        }
    });
    return (
      <>  
        <MenuHeader itemName={name} parentItemName={parentName} />
        {menuLevel === 5 && <div className="List-item-name">{name}</div>}
        <div className={buttonClass}>
          {icons.back}
        </div>
        {title && 
          <div className="Parent-name">{title}</div>}
        <div className="List-wrapper">
          <List
            list={itemsToRender}
            listItemIndex={listItemIndexForS}
            subListItemIndex={indexChild}
            showSubList={showSubList}
            rowAmount={rowAmount}
          />

          {//show scale only if we have more li elements than rows
            list.length > rowAmount &&
              <Scale
                parent={"List"}
                rowAmount={rowAmount}
                listLength={list.length}
                listItemIndex={listItemIndex}
              />
          }
        </div>
      </>
    );
};
  
ListMenu.propTypes = {
    name: PropTypes.string.isRequired,
    parentName: PropTypes.string,
    settings: PropTypes.object,
    title: PropTypes.string,
    menuLevel: PropTypes.number,
    index: PropTypes.number.isRequired,
    indexChild: PropTypes.number,
    showSubList: PropTypes.bool,
};

export default ListMenu;